<template>
  <div v-if="isLoad" class="container-wrapper">
    <a
      href="#"
      class="close-btn"
      role="button"
      @click.prevent="goTo"
    >
      {{ _.get(getStockPolicy, 'closeButtonText', '') || getMain.closeButtonText }}
    </a>

    <section class="container policy-page">
      <p class="policy-page__content" v-html="_.get(getStockPolicy, 'policyText', '') || getMain.policyText" />
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'PolicyPage',
    data () {
      return {
        title: '',
        backLinkText: '',
        content: '',
        componentReady: false
      }
    },
    computed: {
      ...mapGetters(['getMain', 'isLoad', 'getStockPolicy'])
    },

    beforeMount () {
      localStorage.removeItem('stockPolicy')
    },

    beforeDestroy () {
      this.$store.commit('clearStockPolicy')
    },

    methods: {
      goTo () {
        if (this._.get(this.getStockPolicy, 'formSubmitUrl', '')) {
          localStorage.removeItem('stockPolicy')
        }

        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="scss">
  .close-btn {
    display: block;
    width: 200px;
    width: max-content;
    padding: 0 48px;
    margin-bottom: 40px;
    margin-left: auto;
    font-size: 15px;
    line-height: 48px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background: $c-gray-dark;
    border-radius: 24px;
    transition: background-color 0.4s, color 0.4s;

    @include hover {
      background-color: $c-gray;
    }
  }

  .policy-page {
    * {
      color: $c-gray-dark;
    }

    strong {
      font-weight: 900;
    }

    ol,
    ul {
      margin-left: 20px;

      li {
        padding-left: 10px;
      }
    }
  }
</style>
